export default __webpack_public_path__ + "0dfad34b575d1d669e18c35f8c984428.svg";